<template lang="pug">
  router-view
</template>

<script>
  export default {
    beforeCreate () {
      if (this.$route.params.type === undefined) this.$router.push('/condo/rent')
    },
    watch: {
      '$route' (to, from) {
        if (this.$route.params.type === undefined) this.$router.push('/condo/rent')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?ab8efb02